import {ReloadButton} from '@flexinet/ui-components';
import {Box} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';
import {testDefinitionsKeys} from '../hooks/useTestDefinitionsQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: testDefinitionsKeys.all});
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
